<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useDebugStore } from '@/stores/settings/debug'

const { debugSlide } = storeToRefs(useDebugStore())
</script>

<template>
  <div
    class="w-[360px] min-h-full sm:min-h-[740px] sm:w-full xl:max-w-screen-xl"
    :class="{ 'debug-slide': debugSlide }"
  >
    <slot></slot>
  </div>
</template>
